export const en = {
    action_submit: 'Block',
    info: 'Access for',
    title: 'Block access',
};
